<template>
    <PatientHistory :Type="AppServiceID" />
</template>

<script>
import PatientHistory from '@/components/MedicalSupply/PatientHistorySearch.vue'
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default {
    data: function (){
        return {
            AppServiceID :'',            
        }
    },
    components: {
        PatientHistory
    },
    created: function() {     
        this.$emit('update:layout', LayoutDefault);
        this.AppServiceID = this.$store.getters.GetMedicalID;
    },    
    beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetMedicalID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetMedicalID);
    },
}
</script>

<style>

</style>
